import { useEffect, useState } from 'react'

import { pricingAPI } from '../api/services/pricing'
import {
  PricesList,
  PricingData,
  PricingResponse
} from '../api/services/pricing/types.ts'

export const useGetPricingForUser = () => {
  const [userPrices, setUserPrices] = useState<PricesList>()
  const [loading, setLoading] = useState<boolean>(true)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response: PricingResponse<PricingData> | null =
          await pricingAPI.getPricing()

        if (response.error) {
          setError(response.error)
          setLoading(false)
          return
        }

        const data = response.data

        if (data) {
          if (data.main_account_pricing !== null) {
            if (data.user_pricing !== null) {
              setUserPrices(data.user_pricing)
            } else {
              data.main_account_pricing &&
                setUserPrices(data.main_account_pricing)
            }
          } else {
            if (data.user_pricing !== null) {
              setUserPrices(data.user_pricing)
            } else {
              // alert
            }
          }
        }
      } catch {
        setError('Something went wrong while fetching pricing data.')
      } finally {
        setLoading(false)
      }
    }

    fetchData()
  }, [])

  return { userPrices, loading, error }
}
